module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "schedule"
  }, [_vm._t("main")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7874e1a8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./source/js/components/Schedule.vue
// module id = 73
// module chunks = 1